import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup } from "@angular/forms";
import { NewAccessCardService } from "../service/new-access-card.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CardPeopleService } from "../service/card-people.service";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ModalImageAcceptComponent } from "../new-access-card/modal-image-accept/modal-image-accept.component";
import { CustomsValidators } from "../../validators/custom.validators";
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ModalTermsRepositionComponent } from "./modal-terms-reposition/modal-terms-reposition.component";
import { ModErrorComponent } from "../modals/mod-error/mod-error.component";

@Component({
  selector: "app-card-reposition",
  templateUrl: "./card-reposition.component.html",
  styleUrls: ["./card-reposition.component.css"],
})
export class CardRepositionComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private dataApi: NewAccessCardService,
    private dataApiCard: CardPeopleService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {}
  buttonEnable: boolean= true
  cardRepeat = false;
  person: any;
  site: any;
  motives: any;
  selectpickups: any = [];
  formNewcard: UntypedFormGroup;
  submited: boolean;
  radioPress = false;
  progress = 0;

  formatImageError = false;
  sizeImageError = false;
  controlImageninput = false;
  controlNameImageError = false;
  invalidPersonError = false;
  controlNotFound = false;
  controlCountryError = false;

  selectCountry: any;

  getallsitespickups() {
    this.spinner.show("loading");
    this.dataApi.getallsitespickupsmotive().subscribe(
      (data: any) => {
        this.site = data.sites;
        this.selectCountry = data.countries;
        this.motives = data.motives;
        this.spinner.hide("loading");
      },
      (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
    );
  }
  getlang() {
    return sessionStorage.getItem("lang");
  }
  ngOnInit() {
    this.formNewcard = this.formBuilder.group({
      IDPerson: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          CustomsValidators.validateRUN,
        ],
      ],
      motiveId: ["", Validators.required],
      siteId: ["", Validators.required],
      pickupId: ["", Validators.required],
      document: ["nationalId", Validators.required],
      Confirm: [false, Validators.required],
      countryId: [""],
    });
    this.getallsitespickups();
  }

  isrequired(atrr) {
    return this.formNewcard.controls[atrr].hasError("required");
  }
  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }
  openDialogConfirm() {
    this.dialog
      .open(ModalTermsRepositionComponent, {
        panelClass: "myapp-no-padding-dialog",
      })
      .afterClosed()
      .subscribe((accept: boolean) => {
        if (accept) {
          this.formNewcard.controls["Confirm"].setValue(true);
        } else {
        }
      });
  }
  changeSelect(pickup) {
    for (const siteOP of this.site) {
      if (siteOP.siteId === Number(pickup)) {
        this.selectpickups = siteOP.pickup;
     
        if (siteOP.siteName==='') //aplicando mismo fix commit b08ceddc2f18d7cf3297cd329e33dc4a76762a20
        {
          
          this.buttonEnable = false
         
        }
        else 
        {
          this.buttonEnable= true

        }
      }
      this.formNewcard.controls["pickupId"].setValue("");
    }
  }
  newpeople(peopleID) {
    const DoSearch = true;
    this.spinner.show("loading");
    this.controlNotFound = false;
    this.cardRepeat = false;
    if (DoSearch) {
      this.dataApiCard
        .ValidatePeople(
          this.formNewcard.value.document,
          peopleID,
          this.formNewcard.value.countryId,
          "replacement"
        )
        .subscribe(
          (data: any) => {

            if(data.cardHolderMax){
              this.cardRepeat=true;
            }
            if (data.peopleIn != null) {
              const newEntry = {
                mdmid: data.peopleIn.mdmid,
                full_name: data.peopleIn.firstName + " " + data.peopleIn.lastName,
                request_access_card: true,
                email: null,
                nationalId: data.peopleIn.nationalId,
                passportNumber: data.peopleIn.passportNumber,
                type: null
              };
              if (data.peopleIn.employeeType.trim() === "Employee") {
                // Object.assign(newEntry, { email: data.peopleIn.email });
                newEntry.email = data.peopleIn.email;
              } else {
                // Object.assign(newEntry, { email: data.peopleIn.companyEmail });
                newEntry.email = data.peopleIn.companyEmail;
              }
              if (data.peopleIn.nationalId) {
                /*
                Object.assign(newEntry, {
                  nationalId: data.peopleIn.nationalId,
                  type: "Rut",
                });
                */
                //newEntry.nationalId = data.peopleIn.nationalId;
                newEntry.type = "Rut";
              } else {
                /*
                Object.assign(newEntry, {
                  passportNumber: data.peopleIn.passportNumber,
                  type: "Passport",
                });
                */
                //newEntry.passportNumber = data.peopleIn.passportNumber;
                newEntry.type = "Passport";
              }
              this.person = newEntry;
              this.spinner.hide("loading");
            } else if (data.peopleNotValid != null) {
              const newEntry = {
                mdmid: data.peopleNotValid.mdmid,
                full_name: data.peopleNotValid.firstName + data.peopleNotValid.lastName,
                request_access_card: false,
                email: null,
                nationalId: null,
                passportNumber: null,
                type: null
              };
              if (data.peopleNotValid.employeeType.trim() === "Employee") {
                // Object.assign.apply(newEntry, { email: data.peopleNotValid.email });
                newEntry.email = data.peopleNotValid.email;
              } else {
                // Object.assign.apply(newEntry, { email: data.peopleNotValid.companyEmail});
                newEntry.email = data.peopleNotValid.companyEmail;
              }
              if (data.peopleNotValid.nationalId) {
                /*
                Object.assign.apply(newEntry, {
                  nationalId: data.peopleNotValid.nationalId,
                  type: "Rut",
                });
                */
                newEntry.nationalId = data.peopleNotValid.nationalId;
                newEntry.type = "Rut";

              } else {
                /*
                Object.assign.apply(newEntry, {
                  passportNumber: data.peopleNotValid.passportNumber,
                  type: "Passport",
                });
                */
                newEntry.passportNumber = data.peopleNotValid.passportNumber;
                newEntry.type = "Passport";
              }
              this.person = newEntry;
              this.spinner.hide("loading");
            }
            if (data.peopleOut) {
              this.spinner.hide("loading");
              this.controlNotFound = true;
            }
            if(data.CardHolderMax && data.CardHolderMax!=null) this.cardRepeat=true;
            this.spinner.hide("loading");
          },
          (err: any) => {
            this.spinner.hide("loading");

            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }


          }
        );
    }
  }
  add() {
    this.radioPress = true;
    this.controlNameImageError = false;
    this.controlCountryError = false;
    if (!this.formNewcard.controls["document"].hasError("required")) {
      if (!this.formNewcard.controls["IDPerson"].hasError("required")) {
        if (
          this.formNewcard.value.document === "passportNumber" &&
          this.formNewcard.controls["countryId"].value === ""
        ) {
          //validation of nationality pending
          this.spinner.hide("loading");
          this.controlCountryError = true;
          return;
        } else if (
          this.formNewcard.value.document === "nationalId" &&
          this.formNewcard.controls["IDPerson"].hasError("validateRUN")
        ) {
          this.spinner.hide("loading");
          return;
        } else if (
          this.formNewcard.value.document === "nationalId" &&
          !this.formNewcard.controls["IDPerson"].hasError("validateRUN")
        ) {
          let IdSPLIT = this.formNewcard.value.IDPerson.split(".").join("");
          this.formNewcard.controls["IDPerson"].setValue(IdSPLIT);
        }
        this.newpeople(this.formNewcard.value.IDPerson);
      } else {
      }
    } else {
    }
  }

  changeListener($event): void {
    if ($event.target.files.length <= 0) {
      return;
    }
    this.formatImageError = false;
    this.sizeImageError = false;
    this.controlNameImageError = false;
    if ( $event.target.files[0].type === "image/jpeg" || $event.target.files[0].type === "image/jpg") {
      if ($event.target.files[0].size <= 2000000) {
        if (
          !($event.target.files[0].name.toLocaleLowerCase().split(".jp")[0].trim() === this.person.nationalId.toLocaleLowerCase() ||
            $event.target.files[0].name.toLocaleLowerCase().split(".")[0].trim() === this.person.passportNumber.toLocaleLowerCase()
          )
        ) {
          this.controlNameImageError = true;
          $event.srcElement.value = null;
          delete this.person.image_name;
          delete this.person.image;
          this.spinner.hide("loading");
          return;
        }
        this.controlNameImageError = false;
        this.dialog
          .open(ModalImageAcceptComponent, {
            data: $event.target,
            panelClass: "myapp-no-padding-dialog",
          })
          .afterClosed()
          .subscribe((result: any) => {
            this.spinner.show("loading");
            if (result != null) {
              Object.assign(this.person, {
                image_name: result.image_name,
                image: result.image,
              });
              this.controlImageninput = true;
              $event.srcElement.value = null;
            } else {
              $event.srcElement.value = null;
            }
            this.spinner.hide("loading");
          });
      } else {
        if (this.person.image && this.person.image_name) {
          delete this.person.image_name;
          delete this.person.image;
          this.controlImageninput = false;
        }
        this.sizeImageError = true;
        $event.srcElement.value = null;
      }
    } else {
      if (this.person.image && this.person.image_name) {
        delete this.person.image_name;
        delete this.person.image;
        this.controlImageninput = false;
      }
      this.formatImageError = true;
      $event.srcElement.value = null;
    }
  }

  onSubmit() {
    this.submited = true;
    this.invalidPersonError = false;
    if (this.isrequired("motiveId")) {
      this.goTo("motiveSelect");
    } else {
      if (this.isrequired("siteId")) {
        this.goTo("siteSelect");
      } else {
        if (this.isrequired("pickupId")) {
          this.goTo("pickSelect");
        } else {
          //if (!this.isrequired("Confirm") && this.formNewcard.valid) {
            //if (!this.isrequired("Confirm")) {
            if (this.person && this.person.request_access_card) {
              const cardRequest = {
                PickupId: Number(this.formNewcard.value.pickupId),
                MotiveId: Number(this.formNewcard.value.motiveId),
                SiteId: Number(this.formNewcard.value.siteId), //revisar
                Type: false,
                Bulk: false,
                People: [],
              };

              if (this.person.image) {
                cardRequest.People.push({
                  ImageData: this.person.image,
                  MDMID: this.person.mdmid,
                });
              } else {
                cardRequest.People.push({
                  MDMID: this.person.mdmid,
                });
              }
              if (cardRequest.People.length > 0) {
                this.spinner.show("loading");
                this.dataApi.postnewcard(cardRequest).subscribe(
                  (event: HttpEvent<any>) => {
                    switch (event.type) {
                      case HttpEventType.Sent:
                        break;
                      case HttpEventType.ResponseHeader:
                        break;
                      case HttpEventType.UploadProgress:
                        this.progress = Math.round(
                          (event.loaded / event.total) * 100
                        );
                        break;
                      case HttpEventType.Response:
                        if (event.status === 200) {
                          this.router.navigate([
                            "/card-confirmation/" + event.body.requestNumber,
                          ]);
                          this.spinner.hide("loading");
                        }
                        setTimeout(() => {
                          this.progress = 0;
                        }, 1500);
                    }
                  },
                  (err) => {

                    this.spinner.hide("loading");
                    if(err.error.error !== 'Invalid token.') {
                      this.dialog.open(ModErrorComponent, {
                        width: 'auto',
                        panelClass: 'myapp-no-padding-dialog',
                      });
                    }
                  }
                );
              } else {
                this.dialog.open(ModErrorComponent, {
                  width: "auto",
                  panelClass: "myapp-no-padding-dialog",
                });
              }
            } else {
              this.invalidPersonError = true;
            }
        }
      }
    }
  }
}
